import axios from '@/libs/axios'

const userActions = {
    fetchUsers({ commit, dispatch }, searchParams) {
        return axios.get('/users', { params: searchParams })
    },
    fetchUserList({ commit, dispatch }, searchParams) {
        return axios.get('/users/list', { params: searchParams })
    },
    fetchUsersForTableFilter({dispatch}) {
        return new Promise((resolve, reject) => {
            dispatch('fetchUserList')
              .then(response => {
                  const list = []

                  if (response.data.entities) {
                      for (const key in response.data.entities) {
                          list.push({
                              value: response.data.entities[key].id,
                              text: response.data.entities[key].name+' ('+response.data.entities[key].id+')',
                          })
                      }
                  }

                  resolve(list)
              }).catch(error => {
                reject(error)
            })
        })
    },
    fetchUsersForSelect({commit, dispatch}, searchParams) {
        return new Promise((resolve, reject) => {
            dispatch('fetchUserList', searchParams)
                .then(response => {
                    const list = []

                    if (response.data.entities.length) {
                        for (const key in response.data.entities) {
                            list.push({
                                value: parseInt(response.data.entities[key].id),
                                title: response.data.entities[key].name + ' ('+response.data.entities[key].email+' | '+response.data.entities[key].id+')',
                            })
                        }
                    }

                    resolve(list)
                }).catch(error => {
                reject(error)
            })
        })
    },
    fetchUser({ commit, dispatch }, id) {
        return axios.get(`/users/${id}`)
    },
    storeUser({ commit, dispatch }, data) {
        return axios.post('/users', data)
    },
    updateUser({ commit, dispatch }, data) {
        return axios.put(`/users/${data.id}`, data)
    },
    deleteUser({ commit, dispatch }, id) {
        return axios.delete(`/users/${id}`)
    },
}

export default userActions
